import {authMiddleWare} from "./_auth-middle-ware"


export const authRequest = async () => {
    await authMiddleWare();
}




// const getProfileData = authFetch(() => {

// })